export const PREVISIONAL_SIMULATED = 'previsionalSimulated';
